Vue.component('ack-number-slider-input', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-number-slider-input',
  props:{
    label: {
      type: String,
      default: ''
    },
    labelPre: {
      type: String,
      default: ''
    },
    labelSuf: {
      type: String,
      default: ''
    },
    arrayNumbers: {
      type: Array,
      required: true
    },
    initialValue: {
      type: Number,
      required: true
    },
    
  },
  data() {
    return {
      sliderValue: 2,
      values: [4900, 5900, 6900]
    }
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
    returnedValue(){
      return this.values[this.sliderValue - 1]
    },
    isMobile(){
      return this.$parent.isMobile
    },
    rangeStart(){
      return 1
    },
    rangeEnd(){
      return this.values.length
    },
    formattedPrice() {
      return `${this.labelPre} ${this.values[this.sliderValue - 1]} ${this.labelSuf}`
    }
  },
  created() {
    appLog.log('ack-range-input created', LOG_TYPE.debug)
    this.values = this.arrayNumbers
        
    let qry = this.values.find((m)=> {
      return m == this.initialValue
    })
    if(qry != undefined){
      this.sliderValue = this.values.indexOf(qry) + 1
    }
    
    
  },
  mounted() {
    appLog.log('ack-range-input mounted', LOG_TYPE.debug)
    
    // this.maxValue = this.initialMaxValue
    // this.minValue = this.initialMinValue
    
    
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])   
  },
  beforeDestroy() {
    
  },
  watch: {
    isMobile: {
      handler() {
        
        
      },
      deep: false
    },
    sliderValue: {
      handler() {
        
        this.$emit('input', this.returnedValue)
      },
      deep: false
    }
  }
})